export default class UnderlyingAssetType{
    constructor(idInDb, name){
        this.idInDb = idInDb; // can be null
        this.name = name;
    }

    static createFromData(data) {
        if (data == null) throw new Error("Cannot create ContractAggregate from data if data is null.");
        return new UnderlyingAssetType(data.idInDb, data.name);
    }
}